<template>
    <div id="app">
        <router-view/>
        <nv-footer></nv-footer>
    </div>
</template>

<script>
    import nvFooter from './components/footer.vue'
    export default {
        name: 'App',
        data () {
            return {

            }
        },
        components: {
            nvFooter
        },
    }
</script>

<style>
    @import "assets/style/normalize.css";
    @import "assets/style/main.css";

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /*text-align: center;*/
        color: #2c3e50;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue